import { INovaEntity } from './base';
import { isCarrierUser, isInternalUser, isWarehouseUser, type IUser } from './user';

/** Known identifier types; new values may be added without schema changes. */
export const COMPANY_IDENTIFIER_TYPES = [
  'usdot',
  'mc',
  'scac',
  'email_domain',
  'cvor',
  'cnpj',
  'nsc',
  'rntrc',
  'nit'
] as const;

export type CompanyIdentifierType = (typeof COMPANY_IDENTIFIER_TYPES)[number];

export const COMPANY_IDENTIFIER_SOURCES = [
  'warehouse',
  'self_reported',
  'internal_user',
  'highway_lookup'
] as const;

export type CompanyIdentifierSource = (typeof COMPANY_IDENTIFIER_SOURCES)[number];

export const COMPANY_IDENTIFIER_VERIFIED_BY = ['internal_user', 'highway'] as const;

export type CompanyIdentifierVerifiedBy = (typeof COMPANY_IDENTIFIER_VERIFIED_BY)[number];

export interface ICompanyIdentifier extends INovaEntity {
  companyId: string;
  identifierType: CompanyIdentifierType;
  identifierValue: string;
  source?: CompanyIdentifierSource | null;
  verifiedBy?: CompanyIdentifierVerifiedBy | null;
  verifiedAt?: Date | null;
}

export function getSourceByUser(user: IUser): CompanyIdentifierSource {
  if (isInternalUser(user)) {
    return 'internal_user';
  }

  if (isWarehouseUser(user)) {
    return 'warehouse';
  }

  if (isCarrierUser(user)) {
    return 'self_reported';
  }

  return 'self_reported';
}
